export default __webpack_public_path__ + "static/media/minus.3c377ac0.svg";